import { Body1, Body2, H2, H4 } from "melodies-source/Text";
import React from "react";
import { styled } from "styled-components";
import { ReactComponent as AlbumIcon } from "assets/svg/artist-info.svg";

interface Release {
  cover: string;
  name: string;
}

interface Artist {
  image: string;
  name: string;
  genre: string;
}

interface Props {
  artist: Artist;
  release: Release;
}

export const ArtistInfo: React.FC<Props> = ({ artist, release }) => {
  return (
    <Container>
      <Image src={artist.image} alt={artist.name} />
      <Info>
        <H2>{artist.name}</H2>
        {artist.genre && <Body1>{artist.genre}</Body1>}
      </Info>
      {release?.name && (
        <ReleaseContainer>
          {release.cover ? (
            <img src={release.cover} alt={release.name} />
          ) : (
            <AlbumIcon />
          )}
          <div>
            <Body2>Latest Release:</Body2>
            <H4>{release.name}</H4>
          </div>
        </ReleaseContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 20px;
  border: 2px solid #dcdfe0;
  color: #333;
  background: #f7fafc;
  margin-top: 20px;
  padding: 30px;

  ${H2} {
    color: #000;
    line-height: 32px;
    margin-bottom: 4px;
  }

  ${Body1} {
    color: #000;
  }

  ${H4} {
    color: #000;
    line-height: 20px;
  }

  ${({ theme }) => theme.media.mobile} {
    padding: 20px;
    margin-top: 52px;

    ${H2} {
      font-size: 20px;
      line-height: 28px;
    }

    ${Body1} {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

const Image = styled.img`
  border: 1px solid #dcdfe0;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
  margin-top: -95px;
  margin-bottom: 16px;

  ${({ theme }) => theme.media.mobile} {
    width: 100px;
    height: 100px;
    margin-top: -72px;
  }
`;

const Info = styled.div`
  text-align: center;
`;

const ReleaseContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 32px;

  img,
  svg {
    width: 100px;
    height: 100px;
  }

  ${Body2} {
    margin-bottom: 7px;
  }

  ${({ theme }) => theme.media.mobile} {
    ${H4} {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;
